var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAzureIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.84058L5.31269 1.11931L5.31508 6.22804L0.00491268 6.25817L0 1.84058ZM5.31016 6.81663L5.31433 11.9298L0.00416834 11.202L0.0038706 6.78235L5.31016 6.81663ZM5.95417 1.02492L12.9984 0V6.16303L5.95417 6.21884V1.02492ZM13 6.86472L12.9984 13L5.95417 12.0089L5.94435 6.85329L13 6.86472Z",
    fill: "#00ADEF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAzureIcon);
export default __webpack_public_path__ + "static/media/azure-icon.dd6696e0a0a933c6e7b00b2a29f48326.svg";
export { ForwardRef as ReactComponent };